import { MCatalogueState } from "../state/mcatalogueState";
import {
    MRECEIVE_CATALOGUE_LIST, MRECEIVE_CATALOGUE_CATEGORIES, MSET_URL_CATEGORY,
    MIS_LOADING, MCLEAR_FILTERS, MUPDATE_FILTERS, MRECEIVE_CATALOGUE,
    MRECEIVE_CATALOGUE_ITEM, MRECEIVE_CREATED_ORDER, MRECEIVE_DECORATION_TYPE,
    MRECEIVE_DECORATION_LOCATIONS, MUPDATE_CURRENT_ORDER, RECEIVE_MCARTWORK_DETAILS, RECEIVE_MCARTWORKS_LIST, RECEIVE_MDECORATORS_TYPE_LIST, RECEIVE_MDECORATORS_VENDORS_LIST
} from "../actions/mcatalogueActions";
import { RECEIVE_CURRENT_USER } from "../actions/sessionActions";
import { User } from "../../models/User";

export const initState: MCatalogueState = {
    fetchError: false,
    catalogues: {},
    filters: {
        categoryName: '',
        inhouseId: "",
        productName: "",
        productId: "",
        mainSearch: ""
    },
    artworkDetails: {},
    catalogueCustomRows: [],
    artworkList: {},
    urlCategory: '',
    currentOrder: [],
    categories: [],
    loading: false,
    cleared: 0,
    page: 0,
    meta: null,
    count: 1,
}

const MCatalogueReducer = (state: MCatalogueState = initState, action) => {
    switch (action.type) {
        case RECEIVE_CURRENT_USER: {
            const currentUser: User = action.currentUser;
            if (currentUser.portalPermissions && currentUser.portalPermissions.Catalogue[0].allowedOtherContacts) {
                return {
                    ...state,
                    statuses: currentUser.portalPermissions && currentUser.portalPermissions.Catalogue[0].allowedStatus,
                    filters: {
                        ...state.filters,
                        account_id: action.currentUser.accountId,
                        contact_id: !action.currentUser.portalPermissions.Catalogue[0].allowedOtherContacts ? action.currentUser.contactId : '',
                    },
                };
            } else {
                return {
                    ...state,
                    statuses: currentUser.portalPermissions.Catalogue[0].allowedStatus,
                    filters: {
                        ...state.filters,
                        account_id: action.currentUser.accountId,
                        contact_id: !action.currentUser.portalPermissions.Catalogue[0].allowedOtherContacts ? action.currentUser.contactId : '',
                    },
                };
            }
        }
        case MRECEIVE_DECORATION_LOCATIONS: {
            return {
                ...state,
                loading: false,
                decorationLocations: action.payload.data,
            }
        }
        case RECEIVE_MCARTWORK_DETAILS: {
            return {
                ...state,
                loading: false,
                artworkDetails: { ...state.artworkDetails, [action.payload.data.id]: action.payload.data },
            }
        }
        case RECEIVE_MCARTWORKS_LIST: {
            return {
                ...state,
                loading: false,
                artworkList: action.payload,
            }
        }
        case MRECEIVE_DECORATION_TYPE: {
            return {
                ...state,
                loading: false,
                decorationTypes: action.payload.data,
            }
        }
        case MRECEIVE_CATALOGUE_LIST: {
            return {
                ...state,
                loading: false,
                catalogues: { ...action.catalogues },
                count: action.count
            }
        }
        case MRECEIVE_CATALOGUE_CATEGORIES: {
            return {
                ...state,
                loading: false,
                categories: action.payload,
            }
        }
        case MSET_URL_CATEGORY: {
            return {
                ...state,
                filters: { ...state.filters, categoryName: action.payload },
                urlCategory: action.payload,
            }
        }
        case MUPDATE_CURRENT_ORDER: {
            return {
                ...state,
                currentOrder: action.payload,
            }
        }
        case MRECEIVE_CREATED_ORDER: {
            return {
                ...state,
                loading: false,
                catalogueCustomRows: action.payload,
            }
        }
        case MRECEIVE_CATALOGUE: {
            return {
                ...state,
                catalogues: action.payload,
                loading: false,
                fetchError: false,
                count: action.count,
                meta: action.meta,
            }
        }
        case MRECEIVE_CATALOGUE_ITEM: {
            return {
                ...state,
                catalogueItem: action.payload,
                loading: false,
                fetchError: false,
            }
        }
        case MUPDATE_FILTERS: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            }
        }
        case MCLEAR_FILTERS: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    inhouseId: "",
                    productName: "",
                    categoryName: state.urlCategory ? state.urlCategory : "",
                    productId: '',
                    mainSearch: ''
                },
                cleared: state.cleared + 1
            };
        }
        case MIS_LOADING: return {
            ...state,
            loading: action.loading
        }
        case RECEIVE_MDECORATORS_TYPE_LIST: {
            return {
                ...state,
                loading: false,
                decoratorsTypeList: action.payload,                
            }
        }
        case RECEIVE_MDECORATORS_VENDORS_LIST: {
            return {
                ...state,
                loading: false,
                decoratorsVendorsList: action.payload,                
            }
        }
        default:
            return state;
    }
}

export default MCatalogueReducer;